module.exports = __webpack_public_path__ + "img/imgZXGH(32).663894c7.png";